/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Reglament.vue?vue&type=template&id=542a7144"
import script from "./Reglament.vue?vue&type=script&lang=js"
export * from "./Reglament.vue?vue&type=script&lang=js"
import style0 from "./Reglament.vue?vue&type=style&index=0&id=542a7144&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports